import { api } from '@marketplace-web/core-api/core-api-client-util'

import { GetConversationsStatsResp } from '../types/unread-messages'

export const getConversationsStats = () =>
  api.get<GetConversationsStatsResp>('/conversations/stats')
